import { icon } from "./icons";
import type { PillarsContent } from "../i18n/types";

/** Pillar hrefs and accent variants — structural, zipped with the
 * pillar content in the dictionary. */
const PILLAR_META = [
  { variant: "blue", href: "#features" },
  { variant: "green", href: "#security" },
  { variant: "orange", href: "#faq" },
] as const;

export function renderPillars(t: PillarsContent): HTMLElement {
  const root = document.createElement("section");
  root.className = "section pillars";
  root.id = "platform";
  root.innerHTML = `
    <div class="page">
      <div class="pillars__intro section-head--center" data-reveal>
         <h2 class="section__title">${t.title}</h2>
      </div>
      <div class="pillars__grid">
        ${t.pillars.map((p, i) => `
        <article class="pillar pillar--${PILLAR_META[i].variant}" data-reveal${i > 0 ? ` style="--reveal-delay:${i * 80}ms"` : ""}>
          <div class="pillar__metric"><span>${p.metric}</span>${i === 1 ? icon.arrowDown({ size: 22 }) : icon.arrowUp({ size: 22 })}</div>
           <span class="pillar__label">${p.label}</span>
           <p class="pillar__statement">${p.statement}</p>
           <a class="pillar__link" href="${PILLAR_META[i].href}">${p.link} ${icon.arrow({ size: 14 })}</a>
        </article>
        `).join("")}
      </div>
    </div>
  `;
  return root;
}
